export default "__VITE_ASSET__CeLPrI11__"